import { render, staticRenderFns } from "./SmartGuideEditor.vue?vue&type=template&id=64edb9e3&scoped=true&"
import script from "./SmartGuideEditor.vue?vue&type=script&lang=ts&"
export * from "./SmartGuideEditor.vue?vue&type=script&lang=ts&"
import style0 from "./SmartGuideEditor.vue?vue&type=style&index=0&id=64edb9e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64edb9e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VChip,VIcon})
